module.exports = __webpack_public_path__ + "assets/1d3e0c9d9630aafbfd8702342d2c50ca.mp3";